module.exports = __webpack_public_path__ + "img/schedule-top-img.6454d99e.png";